// import { maptype } from '@/config/index'

export default (val) => {
  var arr = [1, 2, 3]
  console.log(arr.length)
  for (var key in arr) {
    console.log(arr, key)
    // if (key.value === val) {
    //   return key.name
    // } else {
    //   return ''
    // }
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/filters/serach-type.js